import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import {
  criarCnaePrefeituraDs,
  inserirOuAtualizar,
  criarServicosIssDs,
} from "../../DataSources";
import ShowError from "../../AppServices";

const template = {
  id: undefined,
  prefeituraId: undefined,
  codigo: undefined,
  descricao: "",
};

export default class CnaePrefeituraForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    template.prefeituraId = UserInfo.getPrefeitura();
    this.cnaePrefeituraDs = criarCnaePrefeituraDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.lcpCodesOptions = {
      editorType: "dxTagBox",
      selectionMode: "multiple",
      searchEnabled: true,
      dataSource: criarServicosIssDs(),
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: true,
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.cnaePrefeituraDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (!data) {
            notify("CNAE não encontrado.", "error");
            this.props.history.push("/cnaeprefeitura");
          }
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }
    if (this.props.match.params.id === undefined) {
      this.setState({ ...template });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem caption="CNAE Prefeitura" colSpan={2} colCount={2}>
              <SimpleItem dataField={"codigo"}>
                <Label text="Código" />
              </SimpleItem>
              <SimpleItem dataField={"codigosLcp116"}>
                <Label text="Códigos LCP 116" />
              </SimpleItem>
              <SimpleItem
                dataField={"descricao"}
                editorType={"dxTextArea"}
                editorOptions={{ height: "50px" }}
                colSpan={2}
              >
                <Label text="Descrição" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Cancelar"
                type="warn"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = this.state;
    inserirOuAtualizar(this.cnaePrefeituraDs, entidade)
      .then(
        function () {
          notify("Cnae cadastrado com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        //ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
